import { useEffect, useRef } from 'react'
import { assetUrl } from '@/lib/asset-url'

// src resolved to the CDN host (same-origin in dev / e2e) at definition, like every public asset — see
// lib/asset-url. Evaluated at module load, after the __root head script has set window.__CDN_URL (client)
// and from process.env.URL_CDN (SSR), so both render identical markup.
const clients = [
  { src: assetUrl('images/client-buscojobs.svg'), alt: 'Buscojobs', width: 200 / 1.5 },
  { src: assetUrl('images/client-segellsmart.png'), alt: 'Segellsmart', width: 438 / 3, height: 214 / 3 },
  { src: assetUrl('images/client-growpath.png'), alt: 'Growpath', width: 550 / 10, height: 550 / 10 },
  { src: assetUrl('images/client-brazoderecho.png'), alt: 'Brazoderecho', width: 2548 / 15, height: 317 / 15 },
  { src: assetUrl('images/client-on-solutions.png'), alt: 'ON Solutions', width: 198 / 1.4, height: 75 / 1.4 },
  {
    src: assetUrl('images/client-ytalentfy.png'),
    alt: 'Talentfy',
    width: 366 / 2.5,
    height: 55 / 2.5,
    style: { clip: 'rect(0,146px,146px,20px)', transform: 'translateX(-20px)' },
  },
  { src: assetUrl('images/client-viventia.svg'), alt: 'Viventia', width: 186 / 1, height: 68 / 1 },
]

export function SlideShow() {
  const animateRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!animateRef.current) return

    const element = animateRef.current
    const keyframes = [{ transform: 'translateX(0)' }, { transform: 'translateX(-50%)' }]

    const animation = element.animate(keyframes, {
      duration: 30000,
      iterations: Infinity,
      easing: 'linear',
    })

    return () => animation.cancel()
  }, [])

  return (
    <section className="relative mx-auto my-20 max-w-225 overflow-hidden">
      {/* Box shadow overlay */}
      <div
        className="pointer-events-none absolute inset-0 z-10"
        style={{
          boxShadow: `
            inset 40px 0px 15px -20px var(--background),
            inset -40px 0px 15px -20px var(--background)
          `,
        }}
      />
      <div
        ref={animateRef}
        className="flex w-695 items-center justify-center"
        style={{
          margin: '0 40px',
          filter: 'var(--filter-image-client)',
        }}
      >
        {/* We put images twice to make the infinite slide effect */}
        {[0, 1].map((key) => (
          <div key={key} className="flex items-center justify-center">
            {clients.map((client) => (
              <img
                key={`${key}-${client.alt}`}
                src={client.src}
                alt={client.alt}
                width={client.width}
                height={client.height}
                className="mx-7.5 my-3.75 opacity-60 transition-opacity hover:opacity-100"
                style={client.style}
              />
            ))}
          </div>
        ))}
      </div>
    </section>
  )
}
